import { ApiModule } from "@/api/api-module"
import routes from './routes'

class ApiDisk extends ApiModule {
  
  volume(){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.volume}`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  volumeAll(){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.volume}all/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }

  createVolume(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.volume, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }

  googleAuth(data){
    return new Promise((resolve, reject) => {
      this.http.post(`${routes.volume}${data.id}/session/`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }

  getDiskInfo(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.volume}${id}/info/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }

  getAuthLink(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.volume}${id}/auth/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }

  deleteDisk(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.volume}${id}/`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }

  editLabel(id, data) {
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.volume}${id}/`, data).then(
        response => resolve(response.data),
        error => reject(this.normalizeError(error))
      )
    });
  }
  
  shared(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.shared).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  trash(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.trash).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  diskFiles(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.volume}${id}/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getDirectoryContent(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.directory}${id}/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  getTrashDirectoryContent(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.trashContent}${id}/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  uploadFile(data, token = null){
    let params = {}
    if(token!=null){
      params = {
        cancelToken: token,
        timeout: 0
      }
    }
    return new Promise((resolve, reject) => {
      this.http.post(routes.file, data, params).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  updateFile(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.file}${id}/`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  deleteFile(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.file}${id}/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  createFolder(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.directory, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  updateFolder(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.directory}${id}/`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        }
      )
    })
  }
  
  deleteFolder(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.directory}${id}/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
      })
    })
  }
  
  getPermissions(id, type){
    return new Promise((resolve, reject) => {
      let route = routes.permissions.replace('{type}',type).replace('{id}',id)
      this.http.get(route).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  addPermission(id, type, data){
    return new Promise((resolve, reject) => {
      let route = routes.permissions.replace('{type}',type).replace('{id}', id)
      this.http.post(route, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  updatePermission(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.updatePermission}${id}/`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  deletePermission(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.deletePermission}${id}/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  getTransfer(id, type){
    return new Promise((resolve, reject) => {
      let route = routes.transfer.replace('{type}',type).replace('{id}',id)
      this.http.get(route).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  deleteTransfer(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.deleteTransfer}${id}/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  getFileContent(id){
    return new Promise((resolve, reject) => {
      let route = routes.fileContent.replace('{id}',id)
      this.http.get(route).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  saveFileContent(id, content){
    return new Promise((resolve, reject) => {
      let route = routes.fileContent.replace('{id}',id)
      this.http.put(route, content).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  deleteTrash(){
    return new Promise((resolve, reject) => {
      this.http.delete(routes.trash).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  recover(id, type){
    return new Promise((resolve, reject) => {
      let route = routes.recover.replace('{type}',type).replace('{id}',id)
      this.http.get(route).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  createLink(type, id, data){
    return new Promise((resolve, reject) => {
      let route = routes.typedlink.replace('{type}',type).replace('{id}',id)
      this.http.post(route, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  getLinks(type, id){
    return new Promise((resolve, reject) => {
      let route = routes.typedlink.replace('{type}',type).replace('{id}',id)
      this.http.get(route).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  updateLink(id, data){
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.link}${id}/`, data).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  deleteLink(id){
    return new Promise((resolve, reject) => {
      this.http.delete(`${routes.link}${id}/`).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  getLinkContent(token){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.linkContent}${token}/`, {baseURL: '/api/public'}).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  getContentByToken(type, id, token){
    let route = routes.contentByToken.replace('{type}',type).replace('{id}',id).replace('{token}',token)
    return new Promise((resolve, reject) => {
      this.http.get(route, {baseURL: '/api/public'}).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  getHistory(file_id){
    let route = routes.getHistory.replace('{file_id}', file_id)
    return new Promise((resolve, reject) => {
      this.http.get(route).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  viewHistory(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.history}${id}/`).then(
        response => {
          resolve(response.data.snapshot);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
  
  checkoutHistory(id){
    let route = routes.checkoutHistory.replace('{id}', id)
    return new Promise((resolve, reject) => {
      this.http.get(route).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(this.normalizeError(error));
        })
    })
  }
}

let apiDisk = new ApiDisk("disk")
export default apiDisk


// WEBPACK FOOTER //
// ./src/apps/disk/api/index.js